export { HotelName, PropertyDetails } from "./PropertyDetails";